import { SUBJECTS, nodeIdOf, subjectPathFromName } from './aprenAiSubjects.mjs';

export { subjectPathFromName };

/**
 * Enllaços a apren.ai (abans sele.ai): els exàmens de Catalunya digitalitzats per practicar-los
 * dinàmics des del mòbil, comprovar les respostes al moment i estudiar amb IA.
 *
 * examenselectivitat continua sent el web de referència de Catalunya a Google: a apren.ai les
 * pàgines de Catalunya surten amb noindex i enllacen cap aquí (aprenAI: seoCopy.YIELDED_REGIONS,
 * amb la mateixa taula al revés). Si una assignatura canvia de nom a apren.ai, el slug vell hi fa
 * un 301 al bo, perquè el número del final és el que compta.
 */
/**
 * Interruptor: false = tot com abans (anuncis de sele.ai, sense la línia d'apren.ai).
 * Encès el 2026-10-09: apren.ai ja té desplegades les URL de la jerarquia (comprovades totes les de SUBJECTS)
 */
export const APRENAI_ON = true;
export const SELEAI_URL = 'https://sele.ai/?step=5&studyType=4&center=220&course=2032';

export const APRENAI_URL = 'https://apren.ai';
const CATALUNYA = `${APRENAI_URL}/selectividad-pau-3/selectivitat-pau-catalunya-234`;

// subject_path d'examenselectivitat → slug de l'assignatura a apren.ai: la taula és a aprenAiSubjects.mjs (també la llegeix generateSeo.js)

/** La pàgina de l'assignatura a apren.ai (o la de Catalunya si no hi és), amb l'origen per a l'analítica */
export function aprenAiUrl(subjectPath, campaign = 'enllac') {
  if (!APRENAI_ON) return SELEAI_URL;
  const slug = subjectPath && SUBJECTS[subjectPath];
  return `${slug ? `${CATALUNYA}/asignatura/${slug}` : CATALUNYA}?utm_source=examenselectivitat&utm_medium=referral&utm_campaign=${campaign}`;
}

/** URL de l'assignatura a apren.ai, sense query (o null si no hi és) */
export function aprenAiSubjectUrl(subjectPath) {
  const slug = subjectPath && SUBJECTS[subjectPath];
  return slug ? `${CATALUNYA}/asignatura/${slug}` : null;
}

/** Id del node de l'assignatura a apren.ai (el número del final del slug), per llegir-ne els apunts */
export function aprenAiNodeId(subjectPath) {
  return nodeIdOf(subjectPath);
}

/** Hi ha exàmens d'aquesta assignatura a apren.ai */
export function hasAprenAi(subjectPath) {
  return APRENAI_ON && !!(subjectPath && SUBJECTS[subjectPath]);
}
